const MODULE_NAME = 'tamogatasKalkulatorService';
class TamogatasKalkulatorService {
	constructor($http, environment) {
		this._$http = $http;
		this._environment = environment;
	}
	calculate(data) {
		var params = {
			hektarSzam: data.hektar.replace(',', '.'),
			fiatalTermelo: data.fiatal,
			okohektar: data.okohektar.replace(',', '.'),
			elozoEvTamogatasOsszeg: data.euro
		};
		return this._$http.post(`${this._environment.backendUrl}/do/kalkulator/tamogatas/kalkulal`, params);
	}
}
TamogatasKalkulatorService.$inject = ['$http', 'environment'];
export default angular.module(MODULE_NAME, [])
	.service('tamogatasKalkulatorService', TamogatasKalkulatorService).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/tamogataskalkulator/tamogataskalkulator-service.js